/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateFamilyExtraConfigBackfillRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/update_family_extra_config_backfill.pb'
import {UpdateFamilyExtraConfigBackfillResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/update_family_extra_config_backfill.pb'


export const updateFamilyExtraConfigBackfill = (request: UpdateFamilyExtraConfigBackfillRequest, options?: CashRequestOptions) => post<UpdateFamilyExtraConfigBackfillRequest, UpdateFamilyExtraConfigBackfillResponse>("/2.0/cash/update-family-extra-config-backfill", request, {...options, rejectOnError: true })